import React, { useState, useEffect } from "react";
import { Mail, Lock, ArrowRight, Loader2 } from "lucide-react";
import logo from '../assets/logo.png';

const HERO_IMAGE =
    "https://autohebdosport.com/images/coches/salones/2025/autopia/segundo-previo/autopia-2025.jpg";

export default function LoginComponent({ loginUser }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 900);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const success = await loginUser({ email, password });
            if (!success) alert("Login fallido. Verifica tus credenciales.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="dyd-auth">
            {/* ─── Panel de marca (solo escritorio) ─── */}
            {!isMobile && (
                <div className="dyd-auth-brand">
                    <div className="dyd-auth-bg" style={{ backgroundImage: `url(${HERO_IMAGE})` }} />
                    <div className="dyd-auth-veil" />
                    <div className="dyd-auth-grid" />

                    <div className="dyd-auth-brand-content">
                        <h1 className="dyd-rise">
                            DRIVINGYOURDREAM
                            <span className="dyd-gradient-text" style={{ display: "block" }}>CLUB</span>
                        </h1>
                        <div className="dyd-auth-rule dyd-rise" style={{ "--i": 1 }} />
                        <p className="dyd-rise" style={{ "--i": 2 }}>
                            Conectamos visionarios, proyectos y oportunidades
                            en el sector automoción.
                        </p>
                    </div>
                </div>
            )}

            {/* ─── Formulario ─── */}
            <div className="dyd-auth-panel">
                {isMobile && (
                    <>
                        <div className="dyd-auth-bg" style={{ backgroundImage: `url(${HERO_IMAGE})` }} />
                        <div className="dyd-auth-veil" />
                    </>
                )}
                <div className="dyd-auth-scrim" />

                <div className="dyd-auth-form dyd-rise">
                    <img src={logo} alt="DrivingYourDream Club" className="dyd-auth-logo" />

                    <h2>Bienvenido de nuevo</h2>
                    <p className="dyd-auth-sub">Accede a tu cuenta del club</p>

                    <form onSubmit={handleSubmit}>
                        <div className="dyd-field">
                            <label className="dyd-label" htmlFor="loginEmail">
                                <Mail size={12} /> Email
                            </label>
                            <input
                                id="loginEmail"
                                className="dyd-input"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="tu@email.com"
                                autoComplete="email"
                                required
                            />
                        </div>

                        <div className="dyd-field">
                            <label className="dyd-label" htmlFor="loginPassword">
                                <Lock size={12} /> Contraseña
                            </label>
                            <input
                                id="loginPassword"
                                className="dyd-input"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                autoComplete="current-password"
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="dyd-btn dyd-btn-primary dyd-btn-block dyd-btn-lg"
                        >
                            {isLoading ? (
                                <>
                                    <Loader2 size={17} className="dyd-spin" />
                                    Iniciando…
                                </>
                            ) : (
                                <>
                                    Iniciar sesión
                                    <ArrowRight size={17} className="dyd-arrow" />
                                </>
                            )}
                        </button>
                    </form>

                    <a href="/register" className="dyd-auth-link">
                        ¿No tienes cuenta? <span>Regístrate</span>
                    </a>
                </div>
            </div>
        </div>
    );
}
